var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H8.00667M11 14H11.0067M17 14H17.0067M14 14H14.0067M20 14H20.0067M20 20V19.4667C20 18.7199 20 18.3466 19.8547 18.0613C19.7268 17.8105 19.5229 17.6065 19.272 17.4787C18.9868 17.3333 18.6134 17.3333 17.8667 17.3333H10.1333C9.3866 17.3333 9.01323 17.3333 8.72801 17.4787C8.47713 17.6065 8.27316 17.8105 8.14532 18.0613C8 18.3466 8 18.7199 8 19.4667V20M20 8V8.53333C20 9.28007 20 9.65344 19.8547 9.93865C19.7268 10.1895 19.5229 10.3935 19.272 10.5213C18.9868 10.6667 18.6134 10.6667 17.8667 10.6667H10.1333C9.3866 10.6667 9.01323 10.6667 8.72801 10.5213C8.47713 10.3935 8.27316 10.1895 8.14532 9.93865C8 9.65344 8 9.28007 8 8.53333V8",
    stroke: "#6C737F",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDivider);
export default __webpack_public_path__ + "static/media/email-divider.f26b951830f3e4ff80ae266b3344991b.svg";
export { ForwardRef as ReactComponent };